import { render, staticRenderFns } from "./TopBottom.vue?vue&type=template&id=6266d08e&scoped=true"
import script from "./TopBottom.vue?vue&type=script&lang=js"
export * from "./TopBottom.vue?vue&type=script&lang=js"
import style0 from "./TopBottom.vue?vue&type=style&index=0&id=6266d08e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6266d08e",
  null
  
)

export default component.exports